import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { selectSpecies } from '~app/actions/wildlife';

import defined from '~app/core/defined';
import { insertOuterDividers } from '~app/core/dividerUtils';

import Divider from './Divider';
import PerfectScrollbarContainer from './PerfectScrollbarContainer';
import WildlifeSpeciesListHeaderCell from './WildlifeSpeciesListHeaderCell';
import WildlifeSpeciesCell from './WildlifeSpeciesCell';

class WildlifeSpeciesList extends Component {

  state = {
    sortedSpecies: [],
  };

  componentWillMount() {
    const sortedSpecies = this.sortSpecies(this.props.filteredSpecies);
    this.selectFirstSpecies(sortedSpecies);
  }

  componentWillReceiveProps(nextProps) {
    // First, sort the filtered species list according to our own predicate.
    let sortedSpecies = this.state.sortedSpecies;
    if (nextProps.filteredSpecies !== this.props.filteredSpecies) {
      sortedSpecies = this.sortSpecies(nextProps.filteredSpecies);
    }

    // Second, select the first sorted species.
    if (nextProps.activeClassFilter !== this.props.activeClassFilter) {
      this.scrollContainer.scrollTop = 0;

      this.selectFirstSpecies(sortedSpecies);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Execute this selectedCell handler in componentDidUpdate so that the
    // container's height is recomputed and so that the selectedCell has
    // be refreshed via a render.
    if (this.props.activeThreatFilter !== prevProps.activeThreatFilter) {
      if (defined(this.selectedCell)) {
        this.scrollContainer.scrollTop =
          Math.max(
            this.selectedCell.offsetTop - (this.scrollContainer.height / 2),
            0);
      }
      else {
        this.scrollContainer.scrollTop = 0;

        this.selectFirstSpecies(this.state.sortedSpecies);
      }
    }
  }

  sortSpecies(speciesList) {
    const sortedSpecies = [...speciesList].sort(
      (a, b) => a.name.localeCompare(b.name));

    this.setState({
      sortedSpecies,
    });

    return sortedSpecies;
  }

  selectFirstSpecies(speciesList) {
    if (speciesList.length > 0) {
      this.props.selectSpecies(this.props.wildlifeContext, speciesList[0]);
    }
    else {
      this.props.selectSpecies(this.props.wildlifeContext, null);
    }
  }

  render() {

    // Clear the selectedCell before we render and reset it via the ref.
    this.selectedCell = null;

    return (
      <div className="WildlifeSpeciesList">
        <PerfectScrollbarContainer
          ref={(elem) => this.scrollContainer = elem}
          horizontalScroll={false}
        >
          <WildlifeSpeciesListHeaderCell
            wildlifeClass={this.props.activeClassFilter}
          />
          {
            insertOuterDividers(
              this.state.sortedSpecies
                .map((species) =>
                  this.renderSpeciesCell(species, this.props.selectedBinomial, this.props.selectSpecies)
                ),
              <Divider />
            )
          }
        </PerfectScrollbarContainer>
      </div>
    );
  }

  renderSpeciesCell(species, selectedBinomial, onSelectSpecies) {
    const selected = selectedBinomial === species.binomial;

    // inputRef allows us to pass our ref-finder to the WildlifeSpeciesCell.
    // The goal is to get the cell's DOM node, not the cell component itself.
    return (
      <WildlifeSpeciesCell
        inputRef={cell => {
          if (defined(cell) && selected) {
            this.selectedCell = cell;
          }
        }}
        key={species.binomial}
        name={species.name}
        selected={selected}
        onClick={() => onSelectSpecies(this.props.wildlifeContext, species)}
      />
    );
  }
}

WildlifeSpeciesList.propTypes = {
  wildlifeContext: PropTypes.string.isRequired,
  activeClassFilter: PropTypes.number.isRequired,
  filteredSpecies: PropTypes.array.isRequired,
  selectedBinomial: PropTypes.string,
};

const mapStateToProps = (state, {wildlifeContext}) => ({
  activeClassFilter: state.wildlife[wildlifeContext].activeClassFilter,
  activeThreatFilter: state.wildlife[wildlifeContext].activeThreatFilter,
  filteredSpecies: state.wildlife[wildlifeContext].filteredSpecies,
  selectedBinomial: state.wildlife[wildlifeContext].selectedSpeciesSummary &&
    state.wildlife[wildlifeContext].selectedSpeciesSummary.binomial,
});

const mapDispatchToProps = {
  selectSpecies,
};

export { WildlifeSpeciesList };
export default connect(mapStateToProps, mapDispatchToProps)(WildlifeSpeciesList);



// WEBPACK FOOTER //
// ./src/components/WildlifeSpeciesList.js